import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Space, Popover, Divider } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import handleDates from 'utils/timeDifference';
import {
  TotalMerchantCountIcon,
  LiveMerchantCountIcon,
  IactiveMerchantCountIcon,
  PendingMerchantIcon,
  LiveNotActiveIcon
} from 'utils/icons';
import './SummaryCard.scss';

const iconMap = {
  0: TotalMerchantCountIcon,
  1: LiveNotActiveIcon,
  2: LiveMerchantCountIcon,
  3: IactiveMerchantCountIcon,
  4: PendingMerchantIcon
};

function SummaryCard({ summary, updatedAt }) {
  const renderSummaryItem = (item, index) => {
    const IconComponent = iconMap[index];
    return (
      <Col
        key={item.title || `item-${index}`}
        xs={24}
        sm={12}
        md={8}
        lg={4}
        xl={4}
        className="summary-item"
      >
        <Space direction="vertical" size="small">
          <Space>
            <IconComponent />
            <span className="span-font-size">{item.title}</span>
            <Popover
              placement="top"
              content={<div style={{ fontSize: '12px' }}>{item.info}</div>}
              overlayStyle={{ width: '300px' }}
            >
              <InfoCircleOutlined style={{ color: '#A0A0A0', cursor: 'pointer' }} />
            </Popover>
          </Space>
          <div className="space-font-size">
            <span>{item.value}</span>
          </div>
        </Space>
      </Col>
    );
  };

  return (
    <div className="referral-summary-card">
      <div className="card-header">
        <span className="last-updated">Last updated {handleDates(updatedAt)}</span>
      </div>
      <Row gutter={[16, 16]} className="card-main-container">
        {summary
          .map((item, index) => [
            renderSummaryItem(item, index),
            index < summary.length - 1 && (
              <Divider
                key={`divider-${item.title || index}`}
                type="vertical"
                className="vertical-divider"
              />
            )
          ])
          .flat()
          .filter(Boolean)}
      </Row>
    </div>
  );
}

SummaryCard.propTypes = {
  summary: PropTypes.instanceOf(Object).isRequired,
  updatedAt: PropTypes.string.isRequired
};

export default SummaryCard;
